import { Datastar as DS } from '~/engine'

export const Datastar = DS
